module.exports = __webpack_public_path__ + "static/media/PMS-Sample.6d033079.ods";